var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.website
    ? _c(
        "a",
        {
          ref: "nofollow",
          staticClass: "document-link",
          attrs: { href: _vm.website, target: "_blank" },
        },
        [_vm._v("Click Here")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }